(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-sidebar"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var trigger  = document.getElementById('filter-mobile-trigger');
  var sidebar  = document.getElementById('filter-sidebar');
  var overlay  = document.getElementById('filter-overlay');
  var closeBtn = document.getElementById('filter-drawer-close');

  if (!trigger || !sidebar) return;

  function openDrawer() {
    sidebar.classList.add('is-open');
    sidebar.setAttribute('aria-modal', 'true');
    if (overlay) overlay.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    sidebar.classList.remove('is-open');
    sidebar.setAttribute('aria-modal', 'false');
    if (overlay) overlay.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', function () {
    var isOpen = sidebar.classList.contains('is-open');
    if (isOpen) { closeDrawer(); } else { openDrawer(); }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  /* Close on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
      closeDrawer();
      trigger.focus();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var mainImg   = gallery.querySelector('#gallery-main-img');
    var thumbs    = gallery.querySelectorAll('.product-gallery__thumb');
    var viewer    = gallery.querySelector('.product-gallery__viewer');

    if (!mainImg || !thumbs.length) return;

    // Thumbnail click — swap main image
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src     = thumb.dataset.src;
        var zoomSrc = thumb.dataset.zoomSrc;
        var alt     = thumb.getAttribute('aria-label');

        mainImg.src = src;
        mainImg.setAttribute('data-zoom-src', zoomSrc);
        mainImg.alt = alt;

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });

    // Keyboard: arrow keys cycle thumbnails
    gallery.addEventListener('keydown', function (e) {
      var active  = gallery.querySelector('.product-gallery__thumb.is-active');
      var all     = Array.from(thumbs);
      var idx     = all.indexOf(active);
      if (e.key === 'ArrowRight') all[(idx + 1) % all.length].click();
      if (e.key === 'ArrowLeft')  all[(idx - 1 + all.length) % all.length].click();
    });

    // Click viewer — open zoom lightbox (simple new tab fallback)
    viewer.addEventListener('click', function () {
      var zoomSrc = mainImg.dataset.zoomSrc || mainImg.src;
      window.open(zoomSrc, '_blank', 'noopener');
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
